import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Award extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "slug", Model.attribute('slug'));
    _defineProperty(this, "year", Model.attribute('year'));
    _defineProperty(this, "description", Model.attribute('description'));
    _defineProperty(this, "startsAt", Model.attribute('startsAt', Model.transformDate));
    _defineProperty(this, "endsAt", Model.attribute('endsAt', Model.transformDate));
    _defineProperty(this, "status", Model.attribute('status'));
    _defineProperty(this, "effectiveStatus", Model.attribute('effectiveStatus'));
    _defineProperty(this, "showLiveVotes", Model.attribute('showLiveVotes'));
    _defineProperty(this, "imageUrl", Model.attribute('imageUrl'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "categories", Model.hasMany('categories'));
    _defineProperty(this, "categoryCount", Model.attribute('categoryCount'));
    _defineProperty(this, "nomineeCount", Model.attribute('nomineeCount'));
    _defineProperty(this, "voteCount", Model.attribute('voteCount'));
    _defineProperty(this, "canViewResults", Model.attribute('canViewResults'));
  }
  isDraft() {
    return this.status() === 'draft';
  }
  isActive() {
    return this.status() === 'active';
  }
  hasEnded() {
    return this.status() === 'ended';
  }
  isPublished() {
    return this.status() === 'published';
  }
  isVotingOpen() {
    const now = new Date();
    const startsAt = this.startsAt();
    const endsAt = this.endsAt();
    return this.isActive() && startsAt && endsAt && now >= startsAt && now <= endsAt;
  }
  canShowVotes() {
    return this.isPublished() || this.isActive() && this.showLiveVotes();
  }

  /**
   * Check if award has effectively ended (status or date-based)
   */
  hasEffectivelyEnded() {
    const status = this.effectiveStatus() || this.status();
    return status === 'ended' || status === 'published';
  }
}
flarum.reg.add('huseyinfiliz-awards', 'common/models/Award', Award);